import { initCustomUI } from './customUI/index';

function initApp(): void {
    initCustomUI();

    // viewport リサイズを ResizeObserver で一元管理し ui:resize として伝播
    const viewportObserver = new ResizeObserver(([entry]) => {
        const { width, height } = entry.contentRect;
        document.dispatchEvent(new CustomEvent('ui:resize', { detail: { width, height } }));
    });
    viewportObserver.observe(document.documentElement);

    queueMicrotask(() => {
        document.dispatchEvent(new CustomEvent('ui:update'));
    });
}

if (typeof window !== 'undefined') {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initApp, { once: true });
    } else {
        initApp();
    }
}